<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      
      <el-form-item label="创建时间" prop="name">
        <el-date-picker
          v-model="value1"
          type="daterange"
          
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
          @change="selectDate"
        ></el-date-picker>
      </el-form-item>
      
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="name" label="业务类型" min-width="100px" align="center"></el-table-column>
        <el-table-column label="微信" min-width="200px" align="center">
          <el-table-column
            prop="payNum"
            label="交易笔数"
            min-width="100px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="payMoney"
            label="交易金额"
            min-width="100px"
            align="center"
          ></el-table-column>
        </el-table-column>
      </el-table>
      
    </template>
    <!-- 新建/修改 -->
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import { fetchList } from '@/api/business/onlinePayStatistics'
import { formatDateTime } from '@/utils/util'
export default {
  name: 'PricingParam',
  extends: BaseTable,
  components: { TableLayout  },
  data () {
    return {
      value1: [new Date(), new Date()],
      // 搜索
      searchForm: {
        endDate: '',
        startDate: ''
      }
    }
  },
  created () {
    this.searchForm.startDate = formatDateTime(new Date(), 'yyyy-MM-dd') + ' 00:00:00'
    this.search()
  },
  methods: {
    reset() {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.value1 = []
      this.$refs.searchForm.resetFields()
      this.search()
    },
    
    search() {
      fetchList(this.searchForm)
        .then(res => {
          this.tableData.list = [
            { name: '支付押金', payNum: res.payNum, payMoney: res.payMoney },
            { name: '退款', payNum: res.refundNum, payMoney: res.refundMoney },
            { name: '未结算', payNum: res.unClosedNum, payMoney: res.unClosedMoney },
            { name: '结算收入', payNum: res.closedNum, payMoney: res.closedMoney },
          ]
        })
    },
    selectDate(v) {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      if (v) {
        this.searchForm.startDate = v[0]
        this.searchForm.endDate = v[1]
      }
      this.search()
    }
  },
}
</script>
